import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    alert('Thank you for your message! We will get back to you shortly.');
  };
  return <main className="w-full" data-id="element-464">
      {/* Hero Section */}
      <section className="w-full bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-465">
        <div className="max-w-7xl mx-auto text-center" data-id="element-466">
          <h1 className="text-4xl md:text-6xl font-serif text-white mb-6 font-[500]" data-id="element-467">
            Contact Us
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-468">
            Have questions? We're here to help.
            <br data-id="element-469" />
            Reach out to our team and we'll get back to you as soon as possible.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="w-full bg-cream py-20 px-4" data-id="element-470">
        <div className="max-w-7xl mx-auto" data-id="element-471">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-472">
            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-473">
              <h2 className="text-3xl font-serif text-gray-900 mb-6 font-[500]" data-id="element-474">
                Send Us a Message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-475">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-476">
                  <Input label="First Name" type="text" placeholder="John" value={formData.name.split(' ')[0] || formData.name} onChange={value => setFormData({
                  ...formData,
                  name: value + ' ' + (formData.name.split(' ')[1] || '')
                })} required data-id="element-477" />
                  <Input label="Last Name" type="text" placeholder="Smith" value={formData.name.split(' ')[1] || ''} onChange={value => setFormData({
                  ...formData,
                  name: (formData.name.split(' ')[0] || '') + ' ' + value
                })} required data-id="element-478" />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-479">
                  <Input label="Email" type="email" placeholder="john@email.com" value={formData.email} onChange={value => setFormData({
                  ...formData,
                  email: value
                })} required data-id="element-480" />

                  <Input label="Phone" type="tel" placeholder="(647) 000-0000" value={formData.phone} onChange={value => setFormData({
                  ...formData,
                  phone: value
                })} required data-id="element-481" />
                </div>

                <div className="flex flex-col" data-id="element-482">
                  <label htmlFor="message" className="text-sm font-medium text-gray-700 mb-2" data-id="element-483">
                    Message <span className="text-red-500" data-id="element-484">*</span>
                  </label>
                  <textarea id="message" rows={6} value={formData.message} onChange={e => setFormData({
                  ...formData,
                  message: e.target.value
                })} placeholder="Tell us more about your inquiry..." required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all resize-none" data-id="element-485" />
                </div>

                <Button type="submit" variant="secondary" size="lg" className="w-full" data-id="element-486">
                  Send Message
                </Button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="space-y-8" data-id="element-487">
              <div data-id="element-488">
                <h2 className="text-3xl font-serif text-gray-900 mb-6 font-[500]" data-id="element-489">
                  Get in Touch
                </h2>
                <p className="text-gray-700 leading-relaxed mb-8" data-id="element-490">
                  Whether you have questions about our services, need help with
                  an application, or want to discuss your specific situation,
                  our team is ready to assist you.
                </p>
              </div>

              <div className="space-y-6" data-id="element-491">
                <div className="flex items-start" data-id="element-492">
                  <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-493">
                    <PhoneIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-494" />
                  </div>
                  <div data-id="element-495">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-496">
                      Phone
                    </h3>
                    <a href="tel:+16476679957" className="text-primary hover:text-primary-dark text-lg" data-id="element-497">
                      +1-647-667-9957
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-498">
                  <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-499">
                    <MailIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-500" />
                  </div>
                  <div data-id="element-501">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-502">
                      Email
                    </h3>
                    <a href="mailto:info@equityrich.ca" className="text-primary hover:text-primary-dark text-lg" data-id="element-503">
                      info@equityrich.ca
                    </a>
                    <p className="text-gray-600 text-sm mt-1" data-id="element-504">
                      We'll respond within 24 hours
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-505">
                  <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-506">
                    <MapPinIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-507" />
                  </div>
                  <div data-id="element-508">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-509">
                      Office
                    </h3>
                    <p className="text-gray-700" data-id="element-510">
                      18 Wynford Dr, Suite 307
                      <br data-id="element-511" />
                      Toronto, ON, M3C 3S2
                      <br data-id="element-512" />
                      Canada
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-accent/10 rounded-xl p-6 mt-8" data-id="element-513">
                <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-514">
                  Prefer to Apply Online?
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-515">
                  Get your free assessment in minutes with our simple online
                  form.
                </p>
                <Button variant="primary" size="md" href="/#form" data-id="element-516">
                  Apply Now
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}